import { render, staticRenderFns } from "./RecomWalletTransactionAdd.vue?vue&type=template&id=9a949f12"
import script from "./RecomWalletTransactionAdd.vue?vue&type=script&lang=js"
export * from "./RecomWalletTransactionAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports